import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { BookingList } from '../../../core/models/booking.model';
import { StatusLabelPipe } from '../../../shared/pipes/status-label.pipe';
import { formatDateTime } from '../../../shared/utils/date.utils';

@Component({
  selector: 'app-booking-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatChipsModule, StatusLabelPipe],
  templateUrl: './booking-card.component.html',
  styleUrl: './booking-card.component.scss',
})
export class BookingCardComponent {
  @Input({ required: true }) booking!: BookingList;
  @Input() showCarInfo = true;
  @Input() showTypeBadge = false;
  formatDateTime = formatDateTime;
}
